/**
 * Urban Floors - gratis staalaanvraag (stalenlijstje + formulier).
 *
 * Vervangt de oude "proefvariant van 0,00 in de winkelwagen" flow. De aanvraag gaat naar het
 * resend-dashboard (POST /api/samples) en wordt pas een Shopify-order (EUR 0,00, tag
 * "staalaanvraag") nadat een medewerker op "Markeer als behandeld" klikt. Daardoor ziet geen
 * enkel advertentieplatform een checkout/Purchase voor een gratis staal.
 *
 * Als de tracker offline is, gaat de aanvraag via het Shopify-contactformulier
 * (tag staalaanvraag + JSON in het bericht). Het lokale dashboard importeert die
 * klanten naar de sample-db. Geen 0,00-checkout, dus geen ad-purchase.
 *
 * API: window.ufSamples.add({ handle, title, sku, variantId, imageUrl }), .open(), .count()
 */
(function () {
  'use strict';

  if (window.ufSamples) return;

  var cfg = window.UF_SAMPLES || {};
  var origin = String(cfg.endpoint || (window.UF_ANALYTICS && window.UF_ANALYTICS.endpoint) || 'https://tracker.urbanfloors.nl').replace(/\/$/, '');
  var API = origin + '/api/samples';
  function ufFetch(url, opts) {
    if (window.UF_OFFLINE && typeof window.UF_OFFLINE.fetch === 'function') {
      return window.UF_OFFLINE.fetch(url, opts);
    }
    return fetch(url, opts);
  }
  function contactLine() {
    if (window.UF_OFFLINE && typeof window.UF_OFFLINE.contactLine === 'function') {
      return window.UF_OFFLINE.contactLine();
    }
    return 'Mail info@urbanfloors.nl of bel 085-0603648.';
  }
  var MAX = parseInt(cfg.max, 10) > 0 ? parseInt(cfg.max, 10) : 4;
  var LIST_KEY = 'uf_sample_list_v1';
  var SRC_KEY = 'uf_sample_src_v1';

  var els = {};
  var submitting = false;
  var lastFocus = null;

  /* ---------- opslag ---------- */

  function readList() {
    try {
      var raw = localStorage.getItem(LIST_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(LIST_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function clearList() {
    try {
      localStorage.removeItem(LIST_KEY);
    } catch (e) {}
  }

  /* ---------- herkomst (utm, gclid, fbclid) ---------- */

  function captureSource() {
    try {
      var p = new URLSearchParams(window.location.search);
      var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
      var hasNew = false;
      var cur = {};
      try {
        cur = JSON.parse(sessionStorage.getItem(SRC_KEY) || '{}') || {};
      } catch (e) {}
      keys.forEach(function (k) {
        var v = p.get(k);
        if (v) {
          cur[k] = String(v).slice(0, 200);
          hasNew = true;
        }
      });
      if (!cur.landingPage) {
        cur.landingPage = (window.location.pathname || '/').slice(0, 300);
        cur.referrer = (document.referrer || '').slice(0, 300);
        hasNew = true;
      }
      if (hasNew) sessionStorage.setItem(SRC_KEY, JSON.stringify(cur));
    } catch (e) {}
  }

  function readSource() {
    var cur = {};
    try {
      cur = JSON.parse(sessionStorage.getItem(SRC_KEY) || '{}') || {};
    } catch (e) {}
    var anonId = '';
    try {
      anonId = localStorage.getItem('uf_vid') || '';
    } catch (e) {}
    return {
      page: (window.location.pathname || '/').slice(0, 300),
      landingPage: cur.landingPage || '',
      referrer: cur.referrer || '',
      utmSource: cur.utm_source || '',
      utmMedium: cur.utm_medium || '',
      utmCampaign: cur.utm_campaign || '',
      utmTerm: cur.utm_term || '',
      utmContent: cur.utm_content || '',
      gclid: cur.gclid || '',
      fbclid: cur.fbclid || '',
      anonId: anonId
    };
  }

  /* ---------- tracking (geen Purchase: alleen eigen event) ---------- */

  function track(name, props) {
    try {
      if (typeof window.ufTrack === 'function') window.ufTrack(name, props || {});
    } catch (e) {}
  }

  function trackRequestToPlatforms(items) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'sample_request', {
          event_category: 'lead',
          items: items.map(function (i) {
            return { item_id: i.sku, item_name: i.title, quantity: 1 };
          })
        });
      }
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'SampleRequest', { num_items: items.length });
      }
    } catch (e) {}
  }

  /* ---------- DOM helpers ---------- */

  function h(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'class') node.className = attrs[k];
        else if (k === 'text') node.textContent = attrs[k];
        else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') node.addEventListener(k.slice(2), attrs[k]);
        else if (attrs[k] !== false && attrs[k] != null) node.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
      });
    }
    (children || []).forEach(function (c) {
      if (c == null) return;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return node;
  }

  function field(label, name, opts) {
    opts = opts || {};
    var id = 'uf-sample-' + name;
    var input = opts.select
      ? h('select', { id: id, name: name, class: 'uf-sample__input', required: !!opts.required }, opts.select)
      : opts.textarea
        ? h('textarea', { id: id, name: name, class: 'uf-sample__input', rows: 2, maxlength: opts.maxlength || 1000 })
        : h('input', {
            id: id,
            name: name,
            class: 'uf-sample__input',
            type: opts.type || 'text',
            required: !!opts.required,
            autocomplete: opts.autocomplete || 'on',
            maxlength: opts.maxlength || 120,
            inputmode: opts.inputmode || null
          });
    return h('div', { class: 'uf-sample__field' + (opts.wide ? ' uf-sample__field--wide' : '') }, [
      h('label', { for: id, class: 'uf-sample__label', text: label + (opts.required ? ' *' : '') }),
      input
    ]);
  }

  /* ---------- styles ---------- */

  function injectStyles() {
    if (document.getElementById('uf-samples-css')) return;
    var css = [
      '.uf-sample-pill{position:fixed;left:16px;bottom:16px;z-index:9990;display:none;align-items:center;gap:8px;padding:12px 18px;border:0;border-radius:999px;background:#523D2A;color:#fff;font:600 14px/1.2 inherit;font-family:inherit;box-shadow:0 6px 20px rgba(0,0,0,.25);cursor:pointer}',
      '.uf-sample-pill.is-visible{display:inline-flex}',
      '.uf-sample-pill__n{display:inline-flex;min-width:22px;height:22px;align-items:center;justify-content:center;border-radius:11px;background:#C47D5A;font-size:12px}',
      /* overlay boven site-header (99999) en alle andere lagen */
      '.uf-sample-overlay{position:fixed;inset:0;z-index:2147483646;display:none;align-items:center;justify-content:center;padding:24px;background:rgba(36,26,18,.55);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);overscroll-behavior:contain}',
      '.uf-sample-overlay.is-open{display:flex}',
      '.uf-sample{position:relative;display:flex;flex-direction:column;width:100%;max-width:680px;max-height:calc(100vh - 48px);max-height:calc(100dvh - 48px);overflow:hidden;border-radius:16px;background:#fff;color:#2b2420;box-shadow:0 24px 70px rgba(20,12,6,.35);font-family:inherit;-webkit-font-smoothing:antialiased}',
      '.uf-sample *{box-sizing:border-box}',
      '.uf-sample__content{display:flex;flex-direction:column;min-height:0;flex:1 1 auto}',
      '.uf-sample__head{flex:0 0 auto;padding:22px 64px 16px 26px;background:linear-gradient(180deg,#faf6f2 0%,#fff 100%);border-bottom:1px solid rgba(82,61,42,.1)}',
      '.uf-sample__badge{display:inline-block;margin:0 0 8px;padding:4px 10px;border-radius:999px;background:rgba(196,125,90,.14);color:#8f4f30;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}',
      '.uf-sample h2{margin:0 0 4px;font-size:24px;line-height:1.2;font-weight:700;color:#3d2c1e;letter-spacing:-.01em}',
      '.uf-sample__lead{margin:0;font-size:14px;line-height:1.5;color:#6B5E52}',
      '.uf-sample__close{position:absolute;top:14px;right:14px;z-index:2;display:flex;align-items:center;justify-content:center;width:38px;height:38px;padding:0;border:0;border-radius:50%;background:rgba(82,61,42,.08);font-size:24px;line-height:1;color:#523D2A;cursor:pointer;transition:background .15s}',
      '.uf-sample__close:hover{background:rgba(82,61,42,.16)}',
      '.uf-sample__form{display:flex;flex-direction:column;min-height:0;flex:1 1 auto}',
      '.uf-sample__scroll{flex:1 1 auto;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:18px 26px 8px}',
      '.uf-sample__section{margin:0 0 8px;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#8f4f30}',
      '.uf-sample__section--spaced{margin-top:22px}',
      '.uf-sample__list{list-style:none;margin:0 0 6px;padding:0;display:grid;gap:8px}',
      '.uf-sample__item{display:flex;align-items:center;gap:12px;padding:8px 12px 8px 8px;border:1px solid rgba(82,61,42,.14);border-radius:12px;background:#fbf9f7}',
      '.uf-sample__item img,.uf-sample__item-ph{width:52px;height:52px;flex:0 0 52px;object-fit:cover;border-radius:8px;background:#efe8e1}',
      '.uf-sample__item-title{flex:1;min-width:0;font-size:14px;line-height:1.35;font-weight:600;color:#3d2c1e}',
      '.uf-sample__remove{flex:0 0 auto;padding:6px 8px;border:0;border-radius:6px;background:transparent;color:#A36245;font-size:13px;font-weight:600;cursor:pointer}',
      '.uf-sample__remove:hover{background:rgba(163,98,69,.1)}',
      '.uf-sample__limit{margin:0;font-size:12px;color:#7a6c5f}',
      '.uf-sample__grid{display:grid;grid-template-columns:1fr 1fr;gap:12px 14px}',
      '.uf-sample__field--wide{grid-column:1/-1}',
      '.uf-sample__label{display:block;margin:0 0 4px;font-size:13px;font-weight:600;color:#3d2c1e}',
      '.uf-sample__input{width:100%;min-height:44px;padding:10px 12px;border:1px solid rgba(82,61,42,.28);border-radius:10px;font:inherit;font-size:16px;line-height:1.3;color:#2b2420;background:#fff;box-shadow:none;transition:border-color .15s,box-shadow .15s}',
      'textarea.uf-sample__input{min-height:70px;resize:vertical}',
      '.uf-sample__input:focus{outline:0;border-color:#C47D5A;box-shadow:0 0 0 3px rgba(196,125,90,.25)}',
      '.uf-sample__hp{position:absolute!important;left:-9999px!important;width:1px;height:1px;overflow:hidden}',
      '.uf-sample__check{display:flex;gap:10px;align-items:flex-start;margin:14px 0 0;font-size:13px;line-height:1.45;color:#4a3f36;cursor:pointer}',
      '.uf-sample__check input{flex:0 0 auto;width:18px;height:18px;margin:1px 0 0;accent-color:#C47D5A}',
      '.uf-sample__check a{color:#8f4f30;text-decoration:underline}',
      '.uf-sample__foot{flex:0 0 auto;padding:14px 26px 18px;border-top:1px solid rgba(82,61,42,.1);background:#fff}',
      '.uf-sample__actions{display:flex;flex-wrap:wrap;gap:10px;margin:0}',
      '.uf-sample__actions .uf-sample__btn:first-child{flex:1 1 220px}',
      '.uf-sample__btn{display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:12px 22px;border-radius:10px;border:1px solid #C47D5A;background:#C47D5A;color:#fff;font:700 15px/1.2 inherit;font-family:inherit;cursor:pointer;transition:background .15s,border-color .15s}',
      '.uf-sample__btn:hover:not(:disabled){background:#b06c4b;border-color:#b06c4b}',
      '.uf-sample__btn:disabled{opacity:.55;cursor:default}',
      '.uf-sample__btn--ghost{background:#fff;color:#523D2A;border-color:rgba(82,61,42,.3);font-weight:600}',
      '.uf-sample__btn--ghost:hover:not(:disabled){background:#f6f1ec;border-color:rgba(82,61,42,.45)}',
      '.uf-sample__trust{margin:10px 0 0;font-size:12px;color:#7a6c5f;text-align:center}',
      '.uf-sample__msg{margin:14px 0 0;padding:10px 12px;border-radius:10px;font-size:14px;line-height:1.4}',
      '.uf-sample__msg--err{background:#fdecea;color:#8a1f17}',
      '.uf-sample__msg[hidden]{display:none}',
      '.uf-sample__done{padding:44px 28px 36px;text-align:center}',
      '.uf-sample__done-ico{display:flex;align-items:center;justify-content:center;width:56px;height:56px;margin:0 auto 14px;border-radius:50%;background:rgba(196,125,90,.15);color:#8f4f30;font-size:28px;line-height:1}',
      '.uf-sample__done h2{margin-bottom:8px}',
      '.uf-sample__done p{margin:0 0 20px;font-size:15px;line-height:1.55;color:#5c4f44}',
      '@media (max-width:640px){.uf-sample-overlay{align-items:flex-end;padding:0}.uf-sample{max-width:none;max-height:94vh;max-height:94dvh;border-radius:18px 18px 0 0}.uf-sample__head{padding:18px 58px 14px 18px}.uf-sample h2{font-size:21px}.uf-sample__scroll{padding:16px 18px 6px}.uf-sample__foot{padding:12px 18px calc(14px + env(safe-area-inset-bottom,0px))}.uf-sample__grid{grid-template-columns:1fr}.uf-sample-pill{bottom:76px}.uf-sample__actions{gap:6px}.uf-sample__actions .uf-sample__btn{flex:1 1 100%}.uf-sample__btn--ghost{min-height:40px;border-color:transparent;background:transparent;text-decoration:underline;font-size:14px}.uf-sample__btn--ghost:hover:not(:disabled){background:transparent;border-color:transparent}.uf-sample__trust{display:none}.uf-sample__close{top:12px;right:12px}}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'uf-samples-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------- UI ---------- */

  function buildPill() {
    els.pill = h('button', { type: 'button', class: 'uf-sample-pill', 'aria-label': 'Open stalenlijst', onclick: function () { open(); } }, [
      h('span', { text: 'Gratis stalen' }),
      (els.pillCount = h('span', { class: 'uf-sample-pill__n', text: '0' }))
    ]);
    document.body.appendChild(els.pill);
  }

  function buildModal() {
    var countrySelect = [
      h('option', { value: 'NL', text: 'Nederland' }),
      h('option', { value: 'BE', text: 'Belgi\u00eb' })
    ];

    els.list = h('ul', { class: 'uf-sample__list' });
    els.limit = h('p', { class: 'uf-sample__limit' });
    els.msg = h('p', { class: 'uf-sample__msg uf-sample__msg--err', role: 'alert', hidden: true });

    els.submit = h('button', { type: 'submit', class: 'uf-sample__btn', text: 'Vraag gratis stalen aan' });
    els.more = h('button', { type: 'button', class: 'uf-sample__btn uf-sample__btn--ghost', text: 'Nog een staal kiezen', onclick: function () { close(); } });

    var fAdr = [
      field('Land', 'country', { select: countrySelect, required: true, autocomplete: 'country' }),
      field('Postcode', 'postalCode', { required: true, autocomplete: 'postal-code', maxlength: 10 }),
      field('Huisnummer', 'houseNumber', { required: true, maxlength: 10, inputmode: 'numeric' }),
      field('Toevoeging', 'houseNumberAddition', { maxlength: 10 }),
      field('Straat', 'street', { required: true, autocomplete: 'address-line1' }),
      field('Plaats', 'city', { required: true, autocomplete: 'address-level2' }),
      field('Opmerking (optioneel)', 'comment', { textarea: true, wide: true })
    ];

    els.form = h('form', { class: 'uf-sample__form', novalidate: false, onsubmit: onSubmit }, [
      h('div', { class: 'uf-sample__scroll' }, [
        h('h3', { class: 'uf-sample__section', text: 'Jouw stalen' }),
        els.list,
        els.limit,
        h('h3', { class: 'uf-sample__section uf-sample__section--spaced', text: 'Contactgegevens' }),
        h('div', { class: 'uf-sample__grid' }, [
          field('Voornaam', 'firstName', { required: true, autocomplete: 'given-name' }),
          field('Achternaam', 'lastName', { required: true, autocomplete: 'family-name' }),
          field('E-mailadres', 'email', { required: true, type: 'email', autocomplete: 'email', wide: true }),
          field('Telefoon (optioneel)', 'phone', { type: 'tel', autocomplete: 'tel', maxlength: 40 }),
          field('Bedrijf (optioneel)', 'company', { autocomplete: 'organization' })
        ]),
        h('h3', { class: 'uf-sample__section uf-sample__section--spaced', text: 'Bezorgadres' }),
        h('div', { class: 'uf-sample__grid' }, fAdr),
        h('div', { class: 'uf-sample__hp', 'aria-hidden': 'true' }, [
          h('label', { for: 'uf-sample-website', text: 'Website' }),
          h('input', { id: 'uf-sample-website', name: 'website', type: 'text', tabindex: '-1', autocomplete: 'off' })
        ]),
        h('label', { class: 'uf-sample__check' }, [
          h('input', { type: 'checkbox', name: 'consent', required: true }),
          h('span', {}, [
            'Ik ga akkoord dat Urban Floors mijn gegevens gebruikt om de stalen te versturen (',
            h('a', { href: cfg.privacyUrl || '/pages/privacy-verklaring', target: '_blank', rel: 'noopener', text: 'privacybeleid' }),
            ').'
          ])
        ]),
        h('label', { class: 'uf-sample__check' }, [
          h('input', { type: 'checkbox', name: 'newsletterOptIn' }),
          h('span', { text: 'Houd me op de hoogte van acties en nieuwe vloeren (optioneel).' })
        ]),
        els.msg
      ]),
      h('div', { class: 'uf-sample__foot' }, [
        h('div', { class: 'uf-sample__actions' }, [els.submit, els.more]),
        h('p', { class: 'uf-sample__trust', text: 'Gratis en vrijblijvend. Je hoeft niets af te rekenen.' })
      ])
    ]);

    els.body = h('div', { class: 'uf-sample__content' }, [
      h('div', { class: 'uf-sample__head' }, [
        h('span', { class: 'uf-sample__badge', text: 'Gratis kleurstalen' }),
        h('h2', { id: 'uf-sample-title', text: 'Stalen aanvragen' }),
        h('p', { class: 'uf-sample__lead', text: 'Kies tot ' + MAX + ' stalen. We sturen ze gratis naar je op.' })
      ]),
      els.form
    ]);

    els.dialog = h('div', { class: 'uf-sample', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'uf-sample-title' }, [
      h('button', { type: 'button', class: 'uf-sample__close', 'aria-label': 'Sluiten', text: '\u00d7', onclick: function () { close(); } }),
      els.body
    ]);

    els.overlay = h('div', { class: 'uf-sample-overlay', onclick: function (e) { if (e.target === els.overlay) close(); } }, [els.dialog]);
    document.body.appendChild(els.overlay);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && els.overlay.classList.contains('is-open')) close();
    });

    wireAddressLookup();
  }

  function renderList() {
    var list = readList();
    els.list.innerHTML = '';
    list.forEach(function (item, index) {
      var li = h('li', { class: 'uf-sample__item' }, [
        item.imageUrl ? h('img', { src: item.imageUrl, alt: '', width: 52, height: 52, loading: 'lazy' }) : h('span', { class: 'uf-sample__item-ph' }),
        h('span', { class: 'uf-sample__item-title', text: item.title }),
        h('button', { type: 'button', class: 'uf-sample__remove', text: 'Verwijder', onclick: function () { remove(index); } })
      ]);
      els.list.appendChild(li);
    });
    els.limit.textContent = list.length >= MAX
      ? 'Je hebt het maximum van ' + MAX + ' stalen gekozen.'
      : list.length + ' van maximaal ' + MAX + ' stalen gekozen.';
    els.submit.disabled = submitting || list.length === 0;
    els.pillCount.textContent = String(list.length);
    els.pill.classList.toggle('is-visible', list.length > 0 && !els.overlay.classList.contains('is-open'));
    els.pill.setAttribute('aria-label', 'Open stalenlijst (' + list.length + ')');
  }

  function showError(text) {
    els.msg.textContent = text;
    els.msg.hidden = !text;
  }

  function resetScroll() {
    var sc = els.form && els.form.querySelector('.uf-sample__scroll');
    if (sc) sc.scrollTop = 0;
  }

  function open() {
    lastFocus = document.activeElement;
    showError('');
    els.overlay.classList.add('is-open');
    els.pill.classList.remove('is-visible');
    renderList();
    resetScroll();
    var first = els.form.querySelector('input[name="firstName"]');
    if (first && readList().length) {
      setTimeout(function () {
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
        resetScroll();
      }, 30);
    }
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    els.overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    renderList();
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus(); } catch (e) {}
    }
  }

  function remove(index) {
    var list = readList();
    var removed = list.splice(index, 1)[0];
    writeList(list);
    if (removed) track('sample_remove', { handle: removed.handle });
    renderList();
  }

  /* ---------- toevoegen ---------- */

  function add(item) {
    if (!item || !item.sku) return false;
    var list = readList();
    var exists = list.some(function (i) { return String(i.sku).toUpperCase() === String(item.sku).toUpperCase(); });
    if (!exists) {
      if (list.length >= MAX) {
        open();
        showError('Je kunt maximaal ' + MAX + ' stalen per aanvraag kiezen. Verwijder eerst een staal.');
        return false;
      }
      list.push({
        handle: String(item.handle || ''),
        title: String(item.title || item.sku),
        sku: String(item.sku),
        variantId: item.variantId ? String(item.variantId) : '',
        imageUrl: item.imageUrl ? String(item.imageUrl) : ''
      });
      writeList(list);
      track('sample_add', { handle: item.handle || '', label: item.title || '' });
    }
    open();
    return true;
  }

  function addFromButton(btn) {
    var sku = btn.getAttribute('data-sku') || '';
    if (!sku) {
      /* geen SKU bekend: val terug op de oude flow */
      return false;
    }
    return add({
      handle: btn.getAttribute('data-product-handle') || '',
      title: btn.getAttribute('data-title') || '',
      sku: sku,
      variantId: btn.getAttribute('data-variant-id') || '',
      imageUrl: btn.getAttribute('data-image') || ''
    });
  }

  /* ---------- NL-adres automatisch aanvullen (PDOK, optioneel) ---------- */

  function wireAddressLookup() {
    var zip = els.form.elements.postalCode;
    var nr = els.form.elements.houseNumber;
    var add2 = els.form.elements.houseNumberAddition;
    var country = els.form.elements.country;
    var timer = null;

    function lookup() {
      if (country.value !== 'NL') return;
      var z = String(zip.value || '').replace(/\s+/g, '').toUpperCase();
      var n = String(nr.value || '').trim();
      if (!/^\d{4}[A-Z]{2}$/.test(z) || !n) return;
      var q = z + ' ' + n + (add2.value ? ' ' + add2.value : '');
      var url = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&fq=type:adres&fl=straatnaam,woonplaatsnaam&q=' + encodeURIComponent(q);
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = data && data.response && data.response.docs && data.response.docs[0];
          if (!doc) return;
          if (!els.form.elements.street.value) els.form.elements.street.value = doc.straatnaam || '';
          if (!els.form.elements.city.value) els.form.elements.city.value = doc.woonplaatsnaam || '';
        })
        .catch(function () {});
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(lookup, 450);
    }

    zip.addEventListener('input', schedule);
    nr.addEventListener('input', schedule);
    add2.addEventListener('input', schedule);
  }

  /* ---------- versturen ---------- */

  function showDone(duplicate) {
    els.body.innerHTML = '';
    els.body.appendChild(
      h('div', { class: 'uf-sample__done' }, [
        h('div', { class: 'uf-sample__done-ico', 'aria-hidden': 'true', text: '\u2713' }),
        h('h2', { text: duplicate ? 'We hebben je aanvraag al' : 'Bedankt! Je aanvraag is ontvangen' }),
        h('p', {
          text: duplicate
            ? 'Voor dit adres is onlangs al een staalaanvraag gedaan. We kijken ernaar en nemen contact op als dat nodig is.'
            : 'Je ontvangt een bevestiging per e-mail. We sturen je gratis stalen zo snel mogelijk op.'
        }),
        h('button', { type: 'button', class: 'uf-sample__btn', text: 'Sluiten', onclick: function () { location.reload(); } })
      ])
    );
  }

  function onSubmit(e) {
    e.preventDefault();
    if (submitting) return;
    var list = readList();
    if (!list.length) {
      showError('Kies eerst minimaal 1 staal.');
      return;
    }
    var f = els.form.elements;
    var payload = {
      firstName: f.firstName.value.trim(),
      lastName: f.lastName.value.trim(),
      email: f.email.value.trim(),
      phone: f.phone.value.trim(),
      company: f.company.value.trim(),
      country: f.country.value,
      postalCode: f.postalCode.value.trim(),
      houseNumber: f.houseNumber.value.trim(),
      houseNumberAddition: f.houseNumberAddition.value.trim(),
      street: f.street.value.trim(),
      city: f.city.value.trim(),
      comment: f.comment.value.trim(),
      newsletterOptIn: !!f.newsletterOptIn.checked,
      website: f.website.value,
      items: list.map(function (i) {
        return { handle: i.handle, title: i.title, sku: i.sku, variantId: i.variantId || undefined, imageUrl: i.imageUrl || undefined };
      }),
      source: readSource()
    };

    submitting = true;
    els.submit.disabled = true;
    els.submit.textContent = 'Versturen\u2026';
    showError('');

    function markSent(duplicate) {
      clearList();
      if (!duplicate && !payload.website) {
        list.forEach(function (i) { track('sample_request', { handle: i.handle, label: i.title }); });
        trackRequestToPlatforms(list);
      }
      showDone(!!duplicate);
    }

    function mailFallbackBody() {
      return [
        'Staalaanvraag (dashboard offline)',
        'Naam: ' + payload.firstName + ' ' + payload.lastName,
        'E-mail: ' + payload.email,
        'Telefoon: ' + payload.phone,
        'Adres: ' + payload.street + ' ' + payload.houseNumber + ' ' + payload.postalCode + ' ' + payload.city,
        'Stalen:',
        (payload.items || [])
          .map(function (i) {
            return '- ' + (i.title || i.handle || '') + (i.sku ? ' (' + i.sku + ')' : '');
          })
          .join('\n'),
        'Pagina: ' + (location.href || ''),
      ].join('\n');
    }

    function compactPayload() {
      return {
        firstName: payload.firstName,
        lastName: payload.lastName,
        company: payload.company,
        email: payload.email,
        phone: payload.phone,
        street: payload.street,
        houseNumber: payload.houseNumber,
        houseNumberAddition: payload.houseNumberAddition,
        postalCode: payload.postalCode,
        city: payload.city,
        country: payload.country,
        comment: payload.comment,
        newsletterOptIn: payload.newsletterOptIn,
        items: payload.items,
        source: payload.source
      };
    }

    function postShopifyContact() {
      if (!window.UF_OFFLINE || typeof window.UF_OFFLINE.postContact !== 'function') {
        return Promise.reject(new Error('Shopify contact ontbreekt'));
      }
      return window.UF_OFFLINE.postContact({
        email: payload.email,
        name: payload.firstName + ' ' + payload.lastName,
        phone: payload.phone,
        tags: 'staalaanvraag',
        body: [
          'Staalaanvraag (Shopify-fallback)',
          'Naam: ' + payload.firstName + ' ' + payload.lastName,
          'E-mail: ' + payload.email,
          'Telefoon: ' + (payload.phone || '—'),
          'Adres: ' + payload.street + ' ' + payload.houseNumber + ' ' + (payload.houseNumberAddition || '') + ', ' + payload.postalCode + ' ' + payload.city,
          'Stalen:',
          (payload.items || [])
            .map(function (item) {
              return '- ' + (item.title || item.handle || '') + (item.sku ? ' (' + item.sku + ')' : '');
            })
            .join('\n'),
          '',
          'UF_STAAL_V1',
          JSON.stringify(compactPayload())
        ].join('\n')
      });
    }

    ufFetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error(data && data.error ? data.error : 'Versturen mislukt. Probeer het later opnieuw.');
          return data;
        });
      })
      .then(function (data) {
        markSent(!!data.duplicate);
      })
      .catch(function (err) {
        var msg = err && err.message ? err.message : 'Versturen mislukt. Probeer het later opnieuw.';
        var down =
          (window.UF_OFFLINE &&
            typeof window.UF_OFFLINE.isDown === 'function' &&
            window.UF_OFFLINE.isDown(err)) ||
          /failed to fetch|networkerror|load failed/i.test(String(msg));
        if (down && payload.website) {
          markSent(false);
          return;
        }
        if (down) {
          return postShopifyContact()
            .then(function () {
              markSent(false);
            })
            .catch(function () {
              msg =
                'Staalaanvraag-server is even offline. ' +
                contactLine() +
                ' We openen een mail met je stalenlijst.';
              if (window.UF_OFFLINE && typeof window.UF_OFFLINE.openMail === 'function') {
                window.UF_OFFLINE.openMail('Staalaanvraag', mailFallbackBody());
              }
              showError(msg);
            });
        }
        showError(msg);
      })
      .then(function () {
        submitting = false;
        if (els.submit) {
          els.submit.textContent = 'Vraag gratis stalen aan';
          renderList();
        }
      });
  }

  /* ---------- init ---------- */

  function init() {
    captureSource();
    injectStyles();
    buildPill();
    buildModal();
    renderList();

    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-uf-sample-open]') : null;
      if (t) {
        e.preventDefault();
        open();
      }
    });

    if (/[?&]staal=1\b/.test(window.location.search) && readList().length) open();
  }

  window.ufSamples = {
    add: add,
    addFromButton: addFromButton,
    open: function () { if (els.overlay) open(); },
    count: function () { return readList().length; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
